import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OwnedContactsStatusDto } from '../../../../../shared/dto';

@Component({
    selector: 'app-start-sync-button',
    templateUrl: './start-sync-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StartSyncButtonComponent {
  @Input() status: OwnedContactsStatusDto;
  @Input() isResync: boolean;

  @Output() startSync: EventEmitter<boolean> = new EventEmitter<boolean>();

  onStartSync(): void {
    this.startSync.emit(this.status && this.isResync);
  }
}
